__webpack_require__.p = "https://myqz.eu/";